import { Heap } from '@datacamp/exercise-tracking';
const trackHeapEvent = (action, exerciseId, value) => Heap.trackEvent({
  heapEventProperties: {
    // @ts-expect-error this is not a valid event_category but is still allowed by Heap https://datacamp.atlassian.net/wiki/spaces/PRODENG/pages/2173796462/Heap+Event+properties#Event-categories
    event_category: 'chat-exercise',
    exerciseId,
    value
  },
  name: action
});
export const trackSendMsgChatGPT = (prompt, exerciseId) => {
  trackHeapEvent('ChatExercise - Send Message ChatGPT', exerciseId, prompt);
};
export const trackSendMsgSimulatorChatGPT = (prompt, exerciseId) => {
  trackHeapEvent('ChatExercise - Send Message SimulatorChatGPT', exerciseId, prompt);
};
export const trackErrorChatGPT = exerciseId => {
  trackHeapEvent('ChatExercise - Error', exerciseId);
};
export const trackChatGPTExerciseView = exerciseId => {
  trackHeapEvent('ChatExercise - ChatGPT Exercise View', exerciseId);
};
export const trackSimulatorChatGPTExerciseView = exerciseId => {
  trackHeapEvent('ChatExercise - SimulatorChatGPT Exercise View', exerciseId);
};